import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=dc6ffc5a&"
import script from "./Founder.vue?vue&type=script&lang=js&"
export * from "./Founder.vue?vue&type=script&lang=js&"
import style0 from "./Founder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports